import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ custom, palette, shape, breakpoints }: Theme) => ({
    root: {
      position: 'relative',
      borderRadius: shape.borderRadius,
      backgroundColor: palette.common.white,
      maxWidth: custom.form.maxWidth,
      padding: '10px 20px 20px',
      marginTop: -35,
      marginBottom: 15,
    },
    consents: {
      backgroundColor: custom.grey[8],
      borderRadius: shape.borderRadius,
      overflow: 'auto',
      maxHeight: 230,
      padding: '10px 0',
    },

    consentsFirstStepRoot: {
      padding: 0,
      margin: '5px 0 0',
    },
    consentsFirstStepWrapper: {
      overflow: 'visible',
      maxHeight: 'max-content',
      padding: '7px 0',
      borderRadius: 12,
      '& > div': {
        padding: '0 12px',
      },
    },
    tooltip: {
      position: 'absolute',
      top: -50,
      right: -30,
      marginLeft: 10,
      [breakpoints.down('sm')]: {
        top: -55,
        right: 5,
      },
    },
    formRow: {
      '& span': {
        lineHeight: '17px',
      },
    },
    formRowMultipleConsents: {
      backgroundColor: 'unset',
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
      '&:not(:first-child)': {
        paddingTop: 0,
      },
      '& label > span': {
        paddingTop: 5,
        paddingBottom: 5,
      },
    },
  })
);
